import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getQueryParameter } from "../../../../utilities";
import { ViewPage, EditPage } from "../index";
import { INavigableComponent } from "../../../../interfaces";
import { ToolbarContextEnum } from "../../../../enums";

interface ItemPageProps {
  config: any;
  data: any;
}

export default function ItemPage({
  config,
  data,
  setBreadcrumbs,
  setToolbarConfig
}: ItemPageProps & INavigableComponent) {
  const location = useLocation();
  const mode = getQueryParameter(location.search, "mode");
  useEffect(() => {
    let context;
    switch (mode) {
      case "add":
        context = ToolbarContextEnum.CreateItem;
        break;
      case "edit":
        context = ToolbarContextEnum.EditItem;
        break;
      default:
        context = ToolbarContextEnum.ViewItem;
        break;
    }

    setToolbarConfig?.({ ...config, context, item: data });
  }, [mode]);

  switch (mode) {
    case "add":
      return <EditPage data={data} />;
    case "edit":
      return <EditPage data={data} />;
    default:
      return <ViewPage data={data} />;
  }
}
